/**
 * Statements (WP4-BILLING, BUILD-PLAN M21) at `/billing/statements`: the
 * statement run decided by each office's cycle rules, sending (text with a
 * pay link, else paper with a QR code), the print queue and cycle rules.
 *
 * Deep link: `/billing/statements?print=<id>,<id>` opens the print view.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'statements',
    title: 'Statements',
    version: '0.1.0',
    owner: 'WP4-BILLING',
    entitlementKey: null,
    permissions: ['ledger.view', 'money.view', 'ledger.post_payment', 'settings.manage'],
    routes: [
      {
        id: 'statements',
        path: '/billing/statements',
        title: 'Statements',
        officeScope: 'location-or-all',
        permission: 'ledger.view',
        readsPhi: true,
      },
    ],
    commands: [
      {
        id: 'statements.open',
        title: 'Run statements',
        keywords: ['statement', 'billing statement', 'mail', 'print statements', 'cycle'],
        routeId: 'statements',
        permission: 'ledger.view',
      },
    ],
    shortcuts: [],
    sseEntityKeys: ['statement', 'pay_link'],
    phiReadPoints: ['statements.run', 'statements.print'],
  }),
  pages: {
    statements: () => import('./StatementsPage.js'),
  },
});
